import api from "../api";

export const getConfigurationByKey = async (key: string): Promise<string[]> => {
  try {
    const { data } = await api.get(`configuration/${key}`);
    return data;
  } catch {
    throw new Error("Ha habido un problema");
  }
};
